<template>
  <Layout>
    <div class="future-all-wrapper">
      <div class="future-flex-wrapper" v-if="companies.length > 0">
        <q-card
          @click="!loading ? (selected = 'all') : ''"
          :class="{ 'active-future': selected === 'all' }"
        >
          <h1>ALL COMPANIES</h1>
        </q-card>
        <q-card
          @click="!loading ? (selected = company.id) : ''"
          square
          v-for="company in companies"
          :key="company.id"
          :class="{ 'active-future': selected === company.id }"
        >
          <h1 v-text="company.name"></h1>
        </q-card>
      </div>

      <div class="rest-wrapper">
        <div v-if="!loading && companies.length > 0">
          <!-- provider
          <div style="max-width: 200px; background: #fff; margin-bottom: 10px">
            <q-select
              label="Select Provider"
              v-model="provider"
              outlined
              :option-label="(pro) => pro.name"
              :option-value="(pro) => pro.key"
              :options="providers"
              label-color="grey-7"
              color="grey-7"
              dense
            >
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="provider"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="provider = ''"
                />
              </template>
            </q-select>
          </div> -->
          <projected-chart
            :title="totalBinder"
            :items="totalItems"
          ></projected-chart>
          <div class="rest-location-wrapper">
            <div
              v-for="location in selectedCompany.locations"
              :key="location.id"
            >
              <projected-chart
                :subtitle="location.monthly_depreciation_assumption"
                :colors="colors"
                :title="location.name"
                :items="locationTotalsBinder(location)"
              ></projected-chart>
            </div>
          </div>
        </div>
        <div
          class="loading-infinite"
          :style="loading ? 'padding:25px' : ''"
          v-if="loading"
        >
          <div>
            <q-spinner-facebook color="primary" size="40px" />
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
      </div>
    </div>
    <q-card
      style="width: 100%; padding: 15px"
      v-if="companies.length == 0 && !loading"
    >
      <empty-value name="company"></empty-value>
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios";
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import ProjectedChart from "../components/summary/ProjectedChart";
import {defaultStatusValues} from "@/enums";
export default {
  components: {
    EmptyValue,
    ProjectedChart,
    Layout,
  },
  metaInfo() {
    return {
      title: `FMS`,
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "Management summary report of total fleet’s future values",
        },
        {
          property: "og:title",
          content: `Management summary report of total fleet’s future values | FMS`,
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      providers: [
        // { name: "JD Power", key: "jd_power" },
        { name: "Manheim", key: "manheim" },
      ],
      provider: "",
      colors: ["#16a596", "#16c79a"],
      selectedCompany: [],
      totalItems: [],
      companies: [],
      selected: "all",
      loading: false,
    };
  },
  async mounted() {
    try {
      this.loading = true;
      await this.getFutureSummary();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async simulationOfSummary(id) {
      this.totalItems = [];
      if (id === "all") await this.getFutureSummary();
      else {
        this.selectedCompany = await this.companies.find(
          (c) => c.id === this.selected
        );
        const { current, months } = this.selectedCompany.total;
        const _current = {
          based_estimated_payoff: this.float(
            current.projected_auction - current.projected_payoff
          ),
          based_on_owner_depr: this.float(
            current.owner_depreciation - current.projected_payoff
          ),
        };
        const _months = months.map((item) => ({
          based_estimated_payoff:
            item.projected_auction === 0
              ? 0
              : this.float(item.projected_auction - item.projected_payoff),
          based_on_owner_depr: this.float(
            item.owner_depreciation - item.projected_payoff
          ),
        }));
        this.totalItems = await [].concat(_current).concat(_months);
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    async getFutureSummary() {
      // const params = { provider: this.provider.key };
      // {
      //   params
      // }
      const { data } = await axios.post("vehicle-analysis/future-summary-values", null, {
        params: {
          statuses: defaultStatusValues
        }
      });
      this.loading = false;
      const { companies, total } = data.data;
      this.companies = companies;
      const { current, months } = total;
      const _current = {
        based_estimated_payoff: this.float(
          current.projected_auction - current.projected_payoff
        ),
        based_on_owner_depr: this.float(
          current.owner_depreciation - current.projected_payoff
        ),
      };
      const _months = months.map((item) => ({
        based_estimated_payoff:
          item.projected_auction === 0
            ? 0
            : this.float(item.projected_auction - item.projected_payoff),
        based_on_owner_depr: this.float(
          item.owner_depreciation - item.projected_payoff
        ),
      }));
      this.totalItems = await [].concat(_current).concat(_months);
    },
  },
  computed: {
    float() {
      return (val) => parseFloat(val.toFixed(2));
    },
    locationTotalsBinder() {
      return (location) => {
        if (!location) return [];
        const { current, months } = location;
        const _current = {
          based_estimated_payoff: this.float(
            current.projected_auction - current.projected_payoff
          ),
          based_on_owner_depr: this.float(
            current.owner_depreciation - current.projected_payoff
          ),
        };
        const _months = months.map((item) => {
          return {
            based_estimated_payoff:
              item.projected_auction === 0
                ? 0
                : this.float(item.projected_auction - item.projected_payoff),
            based_on_owner_depr: this.float(
              item.owner_depreciation - item.projected_payoff
            ),
          };
        });
        return [].concat(_current).concat(_months);
      };
    },
    totalBinder() {
      if (this.selected === "all")
        return `Total of All Companies Fleet's Projected  Revenue/Loss`;
      else
        return `Totals Of ${
          this.companies.find((c) => c.id === this.selected).name
        } Fleet's Projected  Revenue/Loss`;
    },
  },
  watch: {
    selected(n, o) {
      this.selectedCompany = [];
      this.loading = true;
      this.simulationOfSummary(n);
    },
    provider: {
      deep: true,
      handler() {
        this.selectedCompany = [];
        this.loading = true;
        this.totalItems = [];
        this.selected === "all"
          ? this.getFutureSummary()
          : (this.selected = "all");
      },
    },
  },
};
</script>

<style lang="scss">
.rest-location-wrapper {
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  margin-top: 10px;
  justify-content: space-between;
  div {
    margin: 5px 0px;
    flex: 0 1 calc(50% - 10px);
    width: calc(50% - 10px);
    div {
      width: calc(100%);
    }
  }
}
.active-future {
  background: radial-gradient(circle, #35a2ff 0%, #014a88 100%) !important;
  h1 {
    color: #fff;
    font-weight: bold;
  }
}
.future-flex-wrapper {
  display: flex;
  flex-flow: column nowrap;
  flex: 0 0 200px;
  div {
    margin: 0px 5px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    height: 150px;
    border: 1px solid #ccc;
    h1 {
      font-size: 25px;
    }
  }
}
.future-all-wrapper {
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
}
.rest-wrapper {
  margin-left: 10px;
  margin: 0 auto;
  width: calc(100% - 210px);
}

@media only screen and (max-width: 1024px) {
  .future-all-wrapper {
    flex-flow: column nowrap;
    div {
      margin: 5px 0px !important;
    }
  }
  .rest-wrapper {
    width: 100% !important;
  }
  .rest-location-wrapper {
    div {
      flex: 1 !important;
      width: 100%;
    }
  }
}
</style>
